'use client';

import { useTheme } from 'next-themes';

import { Button } from '@/components/ui/button';
import { Half2Icon } from "@radix-ui/react-icons";

export function ModeToggle() {
    const { setTheme, theme } = useTheme();

    return (
        <Button
            variant="ghost"
            size="icon"
            // className="border rounded-full bg-muted border-muted-foreground"
            onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
        >
            {/* <Sun className="hidden h-6 w-[1.3rem] dark:block" /> */}
            {/* <Moon className="h-5 w-5 dark:hidden" /> */}
            <Half2Icon />
            <span className="sr-only">Toggle theme</span>
        </Button>
    );
}
